<template lang="pug">
  li.animal-item(:style='stylePos' :class='dynamicTransition()')
    img.animal(:src='imgSrc')
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    animal: {
      type: Object,
      required: true
    }
  },
  methods: {
    dynamicTransition: function () {
      const maxTransformTime = this.$store.state.animalLifetime / 1000 // sec
      const sec = Math.round(Math.random() * (maxTransformTime - 3)) + 3 // 3s at minimum
      return `transition-${sec}s`
    }
  },
  computed: {
    stylePos: function () {
      const posY = ((Math.random() * 75) + 5) // 5% ~ 80%
      return `top:${posY}%;`;
    },
    imgSrc: function () {
      return require(`../assets/${this.animal.name}.png`)
    }
  },
}
</script>

<style lang="stylus">
.animal-item
  padding-left 4px
  text-align right
  position absolute
  width 100%
.animal
  height 100px

const-opacity = .5s

// max number should be equal to maxTransformTime
for num in (3..30)
  .transition-{num}s
    \transition transform  + " " + num + \s, opacity + " " + const-opacity
</style>